import axios, {AxiosResponse} from 'axios';
import {AppConfig} from '@/app.config';
import {AuthStore} from "@/modules/Auth/stores/auth.store";
import {IBarrier} from "@/interfaces/barrier.interface";

class BarrierResource {
  httpAction({ params }: { params: any }) {
    return (axios.post(AppConfig.apiUrl, {
      action: IBarrier.ACTION,
      params,
      token: AuthStore.state.token,
      version: 1.0
    }) as Promise<AxiosResponse>);
  }
}

export const barrierResource = new BarrierResource();
